import React from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import UserProfileDropdown from "./UserProfileDropdown";
import { clearAuth } from "../utils/helpers";

// Import centralized branding
import { APP_BRANDING } from "../constants/userFacingLabels";

// Import team branding hooks for sport-specific theming
import { useTeam, useTeamBranding, useTeamColors } from "../lib/teamConfig";

const Header = ({ isSidebarOpen, setIsSidebarOpen, showLogo, setShowLogo, }) => {
  const navigate = useNavigate();

  // Get team-specific branding and colors
  const { config } = useTeam();
  const branding = useTeamBranding();
  const colors = useTeamColors();

  // Notifications removed - was showing fake static data
  // TODO: Integrate with real notification system when available

  // Toggle sidebar and save preference
  const handleToggleSidebar = () => {
    const newState = !isSidebarOpen;
    setIsSidebarOpen(newState);
    // Save user preference
    localStorage.setItem("sidebarState", newState ? "open" : "closed");
  };

  const logout = () => {
    clearAuth();
    navigate("/login");
  };

  return (
    <header
      className="sticky top-0 z-40 shadow-sm pr-4 py-3 bg-black text-white border-b border-[#1A1A1A] transition-all duration-200"
    >
      <div className="flex items-center justify-between">
        {/* Left side - Logo and burger menu */}
        <div className="flex items-center space-x-3 xl:space-x-0">
          <button
            onClick={handleToggleSidebar}
            className={`min-h-touch min-w-touch p-3 xl:hidden rounded-lg transition-all duration-200 flex items-center justify-center transform hover:scale-105 hover:bg-white/10 text-[#999999] hover:text-white ${isSidebarOpen ? "rotate-180" : "rotate-0"}`}
            title={isSidebarOpen ? "Close menu" : "Open menu"}
            style={{ willChange: "transform" }}
            aria-label={isSidebarOpen ? "Close navigation menu" : "Open navigation menu"}
          >
            <div className="transition-all duration-200">
              {isSidebarOpen ? <X size={20} /> : <Menu size={20} />}
            </div>
          </button>

          <div className="flex items-center pl-3">
            {/* SLAM logo - clickable to landing page */}
            <Link
              to="/"
              className="hover:opacity-80 transition-opacity"
              aria-label="Go to homepage"
            >
              <img
                src="/SLAM_logo.png"
                alt="SLAM Sports AI"
                className="w-12 h-12 xl:h-16 xl:w-16 cursor-pointer"
                style={{
                  filter: colors?.primary
                    ? `drop-shadow(0 0 6px ${colors.primary}50)`
                    : undefined
                }}
              />
            </Link>
          </div>
        </div>

        {/* Right side - notifications, logout */}
        <div className="flex items-center space-x-3">
          <UserProfileDropdown logout={logout} />
        </div>
      </div>
    </header>
  );
};

export default Header;
